import Breakpoints from '@mixins/breakpoints-mixin';
import { createNewDate, createNewDuration } from '@mixins/moment-mixin.js';

export function formatFromNow(date, timezone) {
    return date ? createNewDate(date, null, timezone).fromNow() : 'never';
}

export function formatDateHuman(date, timezone) {
    return date ? createNewDate(date, null, timezone).format('MMMM DD, YYYY') : null;
}

export function formatDateNoYearHuman(date, timezone) {
    return date ? createNewDate(date, null, timezone).format('MMM-YYYY') : null;
}

export function formatDateNoDay(date, timezone) {
    return date ? createNewDate(date, null, timezone).format('MMMM YYYY') : null;
}

export function formatDateHumanShort(date, timezone) {
    return date ? createNewDate(date, null, timezone).format('MMM DD, YYYY') : null;
}

export function formatDateHumanShortWithSlashes(date, timezone) {
    return date ? createNewDate(date, null, timezone).format('M/D/YYYY') : null;
}

export function formatDateTimeHumanWithWeekday(date, timezone) {
    return date ? createNewDate(date, null, timezone).format('dddd, M/D/YYYY h:mm a') : null;
}

export function formatDateHumanWithTime(date, timezone) {
    if (Breakpoints.computed.isLgAndUpBreakpoint) {
        return createNewDate(date, null, timezone).format('MMMM DD, YYYY h:mm a');
    }
    return createNewDate(date, null, timezone).format('MMM DD, YYYY h:mm a');
}

export function formatDateHumanWithTimeShort(date, timezone) {
    return createNewDate(date, null, timezone).format('M/D/YY h:mm a');
}

export function formatDateHumanTimeOnly(date, timezone) {
    return date ? createNewDate(date, null, timezone).format('h:mm a') : null;
}

export function formatTimeHuman(time) {
    const finishMinutes = createNewDuration(time).asMinutes();

    this.formatTimeFromMinutes(finishMinutes);
}

export function formatTimeFromMinutes(finishMinutes) {
    const minutes = finishMinutes % 60;
    const hours = (finishMinutes - minutes) / 60;

    if (hours === 0) {
        return `${Number(Math.abs(minutes)).toFixed(0)} mins`;
    }

    if (hours > 0 && minutes === 0) {
        return `${Math.abs(hours)} hrs`;
    }

    return `${Math.abs(hours)} hrs ${Number(Math.abs(minutes)).toFixed(0)} mins`;
}

export function formatTimeFromMinutesNoWords(finishMinutes) {
    const minutes = finishMinutes % 60;
    const hours = (finishMinutes - minutes) / 60;

    return `${Math.abs(hours)}:${String(Number(Math.abs(minutes)).toFixed(0)).padStart(2, 0)}`;
}

export function formatTimeString(date, timezone) {
    if (date) {
        return createNewDate(date, null, timezone, 'HH:mm').format('h:mm a');
    }
    return null;
}

export function formatTime(date, timezone) {
    if (date) {
        return createNewDate(date, null, timezone).format('h:mm a');
    }
    return null;
}

export function formatDateOfTheMonth(date, timezone) {
    if (date) {
        return createNewDate(date, null, timezone).format('DD');
    }
    return null;
}

export function format24HourTime(date, timezone) {
    if (date) {
        return createNewDate(date, null, timezone).format('HHmm');
    }
    return null;
}

export function formatDateHumanWithDay(date, timezone) {
    if (date) {
        return createNewDate(date, null, timezone).format('dddd - MMMM D, YYYY');
    }
    return null;
}

export function format(date, displayFormat, timezone) {
    return createNewDate(date, timezone).format(displayFormat);
}

export default {
    filters: {
        formatTimeString(date) {
            return formatTimeString(date);
        },
        formatTime(date) {
            return formatTime(date);
        },
        formatDateHuman(date) {
            return formatDateHuman(date);
        },
        formatDateHumanWithDay(date) {
            return formatDateHumanWithDay(date);
        },
        formatDateHumanShort(date) {
            return formatDateHumanShort(date);
        },
        formatDateHumanWithTime(date) {
            return formatDateHumanWithTime(date);
        },
        formatDateHumanWithTimeShort(date) {
            return formatDateHumanWithTimeShort(date);
        },
        formatDateHumanTimeOnly(date) {
            return formatDateHumanTimeOnly(date);
        },
        formatTimeFromMinutes(finishMinutes) {
            return formatTimeFromMinutes(finishMinutes);
        },
        format(date, displayFormat) {
            return format(date, displayFormat);
        },
    },

    methods: {
        formatFromNow,
        formatDateHuman,
        formatDateNoYearHuman,
        formatDateHumanShort,
        formatDateTimeHumanWithWeekday,
        formatDateHumanWithTime,
        formatDateHumanWithTimeShort,
        formatDateHumanTimeOnly,
        formatTimeHuman,
        formatTimeFromMinutes,
        formatTimeFromMinutesNoWords,
        formatTimeString,
        formatTime,
        formatDateOfTheMonth,
        format24HourTime,
        formatDateHumanShortWithSlashes,
    },
};
